<template>
  <div>
    <Header></Header>
    <div class="wrapper">
      <div class="top">
        <p class="col-12 top-nav text-left"><span class="index">首页</span><span>&gt;</span><span class="second">联系我们</span></p>
        <div class="row">
          <div class="col-md-5 col-12">
            <p class="title text-left">联系我们</p>
            <p class="green-block"></p>
          </div>
          <div class="col-md-7 col-12 text-left">
            <p class="subtitle">上海嘉定及时雨小额贷款股份有限公司</p>
            <p class="desc">邮编：200433</p>
            <p class="desc">电话：4008-212-999（咨询、投诉、举报电话）</p>
            <p class="desc">传真：021-62129999</p>
            <p class="desc">电子信箱：webmaster@jishiyuloan.com</p>
            <p class="desc">通讯地址：上海市静安区石门一路211号（旺旺大厦）17楼</p>
            <p class="subtitle">媒体采访/商务合作</p>
            <p class="desc">合作电话：021-62129999 </p>
            <p class="desc">合作邮箱：webmaster@jishiyuloan.com</p>
            <p class="subtitle">客户服务</p>
            <p class="desc">客户服务热线：4008-212-999（{{serverTime}}） </p>
          </div>
        </div>

      </div>
      <div class="map">
        <img src="../img/contact/map.png" width="100%" alt="">
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
  import Header from './Header'
  import Footer from './Footer'

  export default {
    name: "contact",
    components:{Header,Footer},
    data(){
        let serverTime = '09:00-21:00';
        let now = new Date(), thatTime = new Date('2020/01/24 00:00:00');
        if(now >= thatTime){
            serverTime = '工作日9:00-11:30,13:00-17:30'
        }
        return {
            serverTime:serverTime
        }
    },
    created() {
        console.log(this._data);
    }
  }
</script>

<style scoped lang="less">
  p{margin:0;}
  //pc、laptop
  @media screen and (min-width: 769px) {
    .top{
      width:1300px !important;
      /*padding-left:50px;*/
    }
    .subtitle{
      font-size: 20px;
    }
    .desc {
      font-size: 16px;
    }
  }

  //phone
  @media screen and (max-width: 768px) {
    .wrapper{
      padding-top:90px;
      font-size: 26px;
    }
    .green-block{
      margin-bottom:100px;
    }
    .desc {
      font-size: 26px;
      margin-bottom: 25px;
      margin-right:30px;
    }
    .subtitle{
      font-size: 30px;
    }
  }


  .top{
    margin: 60px auto 48px;
    padding-left:50px;

    .top-nav{
      /*font-size:20px;*/
      margin-bottom:48px;

      .index{
        margin-right:10px;
        color:#01A494;
      }
      .second{
        margin-left:10px;
      }
    }
    .row{
      margin:0;
    }

    .title{
      font-size:56px;
      margin-bottom:56px;
    }
    .green-block{
      width:64px;
      height:8px;
      background:rgba(1,164,148,1);
    }
    .subtitle{
      margin-bottom:17px;
      margin-top:48px;
      font-weight:bold;
      &:first-child{
        margin-top:0;
      }
    }
    .desc{
      margin-bottom: 12px;
      color: rgba(0,0,0,.6)
    }
  }
  .map{
    margin-top:125px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue